import { render, staticRenderFns } from "./ConferenceTileLegacy.vue?vue&type=template&id=7b871d84&scoped=true&"
import script from "./ConferenceTileLegacy.vue?vue&type=script&lang=js&"
export * from "./ConferenceTileLegacy.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceTileLegacy.vue?vue&type=style&index=0&id=7b871d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b871d84",
  null
  
)

export default component.exports